import React, { useEffect, useState } from 'react'
import { Grid,Dimmer,Loader } from 'semantic-ui-react';
import { getActualCommissionRevenueMarketList , getActualCommissionRevenueCategoryList } from 'services/Manager';

import ActualRevenueChart from './ActualCommissionRevenueChart'
import './ActualCommissionRevenuePanel.less'

const ActualCommissionRevenuePanel = ({ filterDataToShow, lastMonths }) => {

    const [aRData, setARDataState] = useState(undefined);
    const [aRPanelHeadingState, setaRPanelHeadingState] = useState("");
    const [aRFilterDataToShowState, setARFilterDataToShowState] = useState("");
    const [firstLevelActualRevenueSelectedObject, setFirstLevelActualRevenueSelectedObject] = useState("");
    const [dataLoading, setDataLoading] = useState(false);
    const [marketListState, setMarketListState] = useState([]);
    const [categoryListState, setCategoryListState] = useState([]);

    useEffect(() => {
        if (lastMonths && aRFilterDataToShowState) {
            getARFiltersData(aRFilterDataToShowState, firstLevelActualRevenueSelectedObject);
        }
    }, [lastMonths]);

    useEffect(() => {
        if (filterDataToShow) {
            getARFiltersData(filterDataToShow);
        }
    }, [filterDataToShow]);

    const getARFiltersData = async (filterDataToShow, cRObject = undefined) => {
        setDataLoading(true);
        let response = undefined;
        let marketListRes = undefined;
        let categoryListRes = undefined;
        
        if (filterDataToShow == "market") {
            // only market higher level data will show
            marketListRes = await getActualCommissionRevenueMarketList(undefined,lastMonths);
            setFirstLevelActualRevenueSelectedObject(undefined)
            setaRPanelHeadingState("Markets")
        } else if (filterDataToShow == "category") {
            // only category higher level data will show
            categoryListRes = await getActualCommissionRevenueCategoryList(undefined,lastMonths);
            setFirstLevelActualRevenueSelectedObject(undefined)
            setaRPanelHeadingState("Categories")
        } else if (filterDataToShow == "categoriesUnderMarket") {
            // will display all categories data under selected market
            categoryListRes = await getActualCommissionRevenueCategoryList(cRObject.id,lastMonths);
            setaRPanelHeadingState("Lead Fee Revenue For " + cRObject.name)
        } else if (filterDataToShow == "marketsUnderCategory") {
            // will display all markets data under selected category
            marketListRes = await getActualCommissionRevenueMarketList(cRObject.id,lastMonths);
            setaRPanelHeadingState("Lead Fee Revenue For " + cRObject.name)
        }

        if (response && response.resStatus == 200) {
            setARDataState(response.data);
        } else {
            setARDataState(undefined);
        }
     
        if(marketListRes && marketListRes.resStatus == 200)
        {    
            setMarketListState(marketListRes.data);
        }else
        {
            setMarketListState([]);
        }
           
        if(categoryListRes && categoryListRes.resStatus == 200)
        {
            
            setCategoryListState(categoryListRes.data);
        }else
        {
            setCategoryListState([]);
        } 
   
        setARFilterDataToShowState(filterDataToShow);
        setDataLoading(false);
    }

    const onARContainerClick = (cRObject) => {
        if (aRFilterDataToShowState == "market") {
            getARFiltersData("categoriesUnderMarket", cRObject)
        } else if (aRFilterDataToShowState == "category") {
            getARFiltersData("marketsUnderCategory", cRObject)
        }
        setFirstLevelActualRevenueSelectedObject(cRObject)
    }

    const onBackArrowClick = () => {
        if (aRFilterDataToShowState == "categoriesUnderMarket") {
            getARFiltersData("market")
        } else if (aRFilterDataToShowState == "marketsUnderCategory") {
            getARFiltersData("category")
        }
    }

    const isOnFirstLevel = () => {
        if (aRFilterDataToShowState == "market" || aRFilterDataToShowState == "category") {
            return true;
        }
        else {
            return false;
        }
    }
    return (
        <div className={"ar-panel"}>
            {
                dataLoading ? 
                ""
                :
                <Grid>
                 <Grid.Row>                                                         
                         <Grid.Column width={16}>
                                <Grid.Row className={`ar-panel-heading`}>
                                    <Grid.Column width={8}>
                                        {
                                            isOnFirstLevel() ? "" :
                                                <i onClick={() => { onBackArrowClick() }} class="arrow circle left icon back_arrow"></i>
                                        }
                                        {aRPanelHeadingState}
                                    </Grid.Column>
                                </Grid.Row>
                         </Grid.Column>
                         {
                            (aRFilterDataToShowState == "market" || aRFilterDataToShowState == "marketsUnderCategory") &&
                            marketListState.map((market,index) => {
                                return (
                                    <>
                                    <Grid.Column width={5}>
                                            <ActualRevenueChart 
                                            key={`market-${market.id}-${index}`}
                                            lastMonths={lastMonths}
                                            type="market"
                                            market={{id : market.marketID, name: market.marketName}}
                                            category={firstLevelActualRevenueSelectedObject} // in case of markets showed this cRObject contain category info
                                            isOnFirstLevel={isOnFirstLevel} 
                                            onARContainerClick={onARContainerClick} >
                                            </ActualRevenueChart>
                                        </Grid.Column>
                                        </>
                                )
                            })
                         }
                         {
                            (aRFilterDataToShowState == "category" || aRFilterDataToShowState == "categoriesUnderMarket") &&
                            categoryListState.map((category,index) => {
                                return (
                                    <>
                                    <Grid.Column width={5}>
                                            <ActualRevenueChart 
                                            key={`category-${category.id}-${index}`}
                                            lastMonths={lastMonths}
                                            type="category"
                                            category={{id : category.categoryID, name: category.categoryName}}
                                            market={firstLevelActualRevenueSelectedObject} // in case of category showed this cRObject contain market info                                      
                                            isOnFirstLevel={isOnFirstLevel} 
                                            onARContainerClick={onARContainerClick} >
                                            </ActualRevenueChart>
                                        </Grid.Column>
                                        </>
                                )
                            })
                         }
                 </Grid.Row>
                </Grid>
            }
        </div>
    )
}

export default ActualCommissionRevenuePanel